import SettingsRemoteIcon from '@mui/icons-material/SettingsRemote';
import { SvgIcon } from '@mui/material';
import { ReactComponent as BOLT } from 'assets/images/icons/Bolt.svg';
import { ReactComponent as Celsius } from 'assets/images/icons/celsius.svg';
import { ReactComponent as CO2 } from 'assets/images/icons/CO2.svg';
import { ReactComponent as CoolWaterTap } from 'assets/images/icons/CoolWaterTap.svg';
import { ReactComponent as FanSpeed } from 'assets/images/icons/FanSpeed.svg';
import { ReactComponent as OCCUPANCY } from 'assets/images/icons/OCCUPANCY.svg';
import { ReactComponent as OnOff } from 'assets/images/icons/OnOff.svg';
import { ReactComponent as PM25 } from 'assets/images/icons/pm2.5.svg';
import { ReactComponent as RH } from 'assets/images/icons/rh.svg';
import { ReactComponent as Temperature } from 'assets/images/icons/temperature.svg';
import { ReactComponent as TVOC } from 'assets/images/icons/TVOC.svg';

const iconStyle = { color: '#000', scale: '3' };

// all the measurements key names should be exactly the same as their DB table columns names.z
export const ControllerChartFields = {
  on_off: {
    db_col_name: 'on_off',
    display_value: 'ON/OFF',
    icon: (
      <SvgIcon sx={iconStyle}>
        <OnOff />
      </SvgIcon>
    ),
    iconSize: '.8rem',
  },
  channel_1: {
    db_col_name: 'channel_1',
    display_value: 'Channel 1',
    icon: (
      <SvgIcon sx={iconStyle}>
        <OnOff />
      </SvgIcon>
    ),
    iconSize: '.8rem',
  },
  channel_2: {
    db_col_name: 'channel_2',
    display_value: 'Channel 2',
    icon: (
      <SvgIcon sx={iconStyle}>
        <OnOff />
      </SvgIcon>
    ),
    iconSize: '.8rem',
  },
  kwh_5min: {
    db_col_name: 'kwh_5min',
    display_value: 'KWH',
    icon: (
      <SvgIcon sx={iconStyle}>
        <BOLT />
      </SvgIcon>
    ),
    iconSize: '.6rem',
  },
  control: {
    db_col_name: 'control',
    display_value: 'Control',
    icon: (
      <SvgIcon sx={iconStyle}>
        <SettingsRemoteIcon />
      </SvgIcon>
    ),
    iconSize: '.7rem',
  },
  // mode: {
  //   db_col_name: 'mode',
  //   display_value: 'AC Mode',
  //   icon: (
  //     <SvgIcon sx={iconStyle}>
  //       <Control />
  //     </SvgIcon>
  //   ),
  //   iconSize: '.7rem',
  // },
  fan_speed: {
    db_col_name: 'fan_speed',
    display_value: 'Fan Speed',
    icon: (
      <SvgIcon sx={iconStyle}>
        <FanSpeed />
      </SvgIcon>
    ),
    iconSize: '.8rem',
  },
  temp_set_point: {
    db_col_name: 'temp_set_point',
    display_value: 'Set Point',
    icon: (
      <SvgIcon sx={{ ...iconStyle, width: 10 }}>
        <Celsius />
      </SvgIcon>
    ),
    iconSize: '.7rem',
  },
  cool_water_valve: {
    db_col_name: 'cool_water_valve',
    display_value: 'Cool Water',
    icon: (
      <SvgIcon sx={iconStyle}>
        <CoolWaterTap />
      </SvgIcon>
    ),
    iconSize: '.8rem',
  },
  occupancy: {
    db_col_name: 'occupancy',
    display_value: 'Occupancy',
    icon: (
      <SvgIcon sx={iconStyle}>
        <OCCUPANCY />
      </SvgIcon>
    ),
    iconSize: '.8rem',
  },
  motion_counter: {
    db_col_name: 'motion_counter',
    display_value: 'Motion',
    icon: (
      <SvgIcon sx={iconStyle}>
        <OCCUPANCY />
      </SvgIcon>
    ),
    iconSize: '.8rem',
  },
  co2_max: {
    db_col_name: 'co2_max',
    display_value: 'Co2',
    icon: (
      <SvgIcon sx={iconStyle}>
        <CO2 />
      </SvgIcon>
    ),
    iconSize: '.8rem',
  },
  temperature_avg: {
    db_col_name: 'temperature_avg',
    display_value: 'Temperature',
    icon: (
      <SvgIcon sx={iconStyle}>
        <Temperature />
      </SvgIcon>
    ),
    iconSize: '.8rem',
  },
  rh: {
    db_col_name: 'rh',
    display_value: 'RH',
    icon: (
      <SvgIcon sx={iconStyle}>
        <RH />
      </SvgIcon>
    ),
    iconSize: '.8rem',
  },
  mass_pm_2_5_max: {
    db_col_name: 'mass_pm_2_5_max',
    display_value: 'PM 2.5',
    icon: (
      <SvgIcon sx={iconStyle}>
        <PM25 />
      </SvgIcon>
    ),
    iconSize: '.8rem',
  },
  tvoc_avg: {
    db_col_name: 'tvoc_avg',
    display_value: 'TVOC',
    icon: (
      <SvgIcon sx={iconStyle}>
        <TVOC />
      </SvgIcon>
    ),
    iconSize: '.8rem',
  },
};

export const ControllerCurrentDataFields = {
  on_off: {
    db_col_name: 'on_off',
    display_value: 'ON/OFF',
  },
  mode: {
    db_col_name: 'mode',
    display_value: 'Mode',
  },
  fan_speed: {
    db_col_name: 'fan_speed',
    display_value: 'Fan Speed',
  },
  cool_water_valve: {
    db_col_name: 'cool_water_valve',
    display_value: 'Cool Water',
  },
  hot_water_valve: {
    db_col_name: 'hot_water_valve',
    display_value: 'Hot Water',
  },
  temp_set_point: {
    db_col_name: 'temp_set_point',
    display_value: 'Setpoint',
  },
  cooling_output: {
    db_col_name: 'cooling_output',
    display_value: 'Cooling Output',
  },
  heating_output: {
    db_col_name: 'heating_output',
    display_value: 'Heating Output',
  },
  heating_elements: {
    db_col_name: 'heating_elements',
    display_value: 'Heating Elements',
  },
  channel_1: {
    db_col_name: 'channel_1',
    display_value: 'Channel 1',
  },
  channel_2: {
    db_col_name: 'channel_2',
    display_value: 'Channel 2',
  },
};
